// WebVitalsLoader.jsx
import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import { webVitals as webVitalsDebug } from '../resource/debug.js';
import { initWebVitals } from '../resource/webVitals.js';
import trackMixpanel, { EventTypes } from '../resource/mixpanel.js';

const webVitalsLog = webVitalsDebug.extend('log');

const DELAY_LOADING_MSEC = 10000; // TODO: remote config
const listenEvents = ['mousemove', 'scroll', 'click'];

export const WebVitalsLoader = ({ enableWebVitals = true }) => {
  const idleCallback = useRef();
  const timer = useRef();

  const onReport = metric => {
    // there is no way for web-vitals to remove the onReport callback
    // use enableWebVitals to decide log and tracking or not
    if (!enableWebVitals) return;

    webVitalsLog(metric);

    trackMixpanel({
      type: EventTypes.USER_WEB_VITALS_METRIC_SENT,
      payload: metric,
    });
  };

  const loadWebVitals = () => {
    clearSideEffects();
    initWebVitals({ onReport });
  };

  const initTimeout = () => {
    timer.current = setTimeout(loadWebVitals, DELAY_LOADING_MSEC);
  };

  const clearSideEffects = () => {
    listenEvents.forEach(event => {
      document.removeEventListener(event, loadWebVitals);
    });
    cancelIdleCallback(idleCallback.current);
    clearTimeout(timer.current);
  };

  useEffect(() => {
    idleCallback.current = requestIdleCallback(initTimeout);
    listenEvents.forEach(event => {
      document.addEventListener(event, loadWebVitals);
    });

    return () => {
      clearSideEffects();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

WebVitalsLoader.propTypes = {
  enableWebVitals: PropTypes.bool,
};

export default WebVitalsLoader;
